import React from "react";

function EntityHeader({ title, add, warning, path, body, clientId, ...rest }) {
  return (
    <div {...rest}>
      <div className="row">
        <div className="col-11 h5 border-bottom">{title}</div>
        <div className="col-1 ">
          {path && (
            <i
              className="fas fa-plus-circle fa-lg"
              style={{ color: "rgba(0, 118, 168, 1)" }}
              onClick={() => {
                if (path === "dialog") {
                  const url =
                    process.env.REACT_APP_ORG +
                    "/cs/dialog/rundialog.aspx?DialogId=%7b5B858DC9-AAD7-47DB-B886-6B5D984AF48D%7d&EntityName=contact&ObjectId=" +
                    clientId;
                  window.open(
                    url,
                    "dialog",
                    "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=500,height=600"
                  );
                }
                if (path === "medication") {
                  const cbUrl =
                    process.env.REACT_APP_ORG.toLowerCase() ===
                    "https://ccplive.safy.org"
                      ? "https://careboard.safy.org"
                      : "https://d365base-cb.safy.org";
                  const url = `${cbUrl}/PatientForm/NewMedication?patientId=${clientId}&ReturnUrl=Contact/Details`;
                  window.open(url, title);
                } else {
                  const url = process.env.REACT_APP_ORG + path;
                  window.open(url, title);
                }
              }}
            />
          )}
          {add && (
            <i
              className="fas fa-plus-circle fa-lg"
              style={{ color: "rgba(0, 118, 168, 1)" }}
              onClick={add}
            />
          )}
          {warning && (
            <i className="fas fa-exclamation-circle fa-lg" title={warning}></i>
          )}
        </div>
      </div>
      {body && <div>{body}</div>}
    </div>
  );
}

export default EntityHeader;
